import React, { useContext, useEffect, useState } from "react";
import "./CheckOut.css";
import { useLocation } from "react-router-dom";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AuthContext } from "../../context/AuthContext";
import toast from "react-hot-toast";
import confetti from "canvas-confetti";
import { Helmet } from "react-helmet-async";

function CheckOut() {
  const { userId, isAuthenticated } = useContext(AuthContext);
  const location = useLocation();
  const plan = new URLSearchParams(location.search).get("plan");
  const [period, setPeriod] = useState("1"); // Default period is 1 month
  const [renewalDate, setRenewalDate] = useState(calculateRenewalDate("1"));
  const [invoiceId, setInvoiceId] = useState(0);
  const accessToken = localStorage.getItem("token");
  // Function to calculate the renewal date based on the selected period
  function calculateRenewalDate(selectedPeriod) {
    const currentDate = new Date();
    if (selectedPeriod === "1") {
      currentDate.setMonth(currentDate.getMonth() + 1); // Add 1 month
    } else if (selectedPeriod === "12") {
      currentDate.setFullYear(currentDate.getFullYear() + 1); // Add 1 year
    }
    return currentDate.toLocaleDateString(); // Format the date
  }

  // Handle period selection change
  const handlePeriodChange = (event) => {
    const selectedPeriod = event.target.value;
    setPeriod(selectedPeriod);
    setRenewalDate(calculateRenewalDate(selectedPeriod));
  };
  useEffect(() => {
    setPeriod(plan === "monthly" ? "1" : "12");
    const duration = 3 * 1000; // Duration of the celebration in milliseconds
    const end = Date.now() + duration;

    const colors = ["#101920", "#0bceda", "#25ebac", "#cbd5e1", "#1cdbc9"]; // Custom colors

    const frame = () => {
      confetti({
        particleCount: 5,
        angle: 70,
        spread: 40,
        startVelocity: 40,
        origin: { x: 0, y: 0.8 }, // Left corner
        colors,
      });

      confetti({
        particleCount: 5,
        angle: 110,
        spread: 40,
        startVelocity: 40,
        origin: { x: 1, y: 0.8 },
        colors,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };
    frame();
  }, [plan]);

  const handlePay = async () => {
    const _plan = period === "1" ? "monthly" : "annual";
    if (!isAuthenticated) {
      window.location.href = `/signup?redirect=/checkout?plan=${_plan}`;
      return;
    }
    // Log the generated URL for debugging
    const url = `${process.env.REACT_APP_BACKEND_URL}/get_checkout_url/${userId}?plan=${_plan}`;
    console.log("Request URL:", url);

    // Define the fetch promise
    const myPromise = fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
      },
    });

    // Use toast.promise for user feedback
    toast
      .promise(
        myPromise.then(async (res) => {
          const data = await res.json();
          console.log(data);
          if (!res.ok) {
            throw new Error(data.error || "Failed to Load Payment.");
          }
          return data; // Return successful response
        }),
        {
          loading: "Processing payment...",
          success: "Redirecting to payment...",
          error: (err) => err.message || "Failed to process payment.",
        }
      )
      .then((data) => {
        // Check if data has a checkout URL
        if (data.checkout_url) {
          window.location.href = data.checkout_url; // Redirect to the checkout page
        } else {
          throw new Error("Invalid response: Checkout URL not provided.");
        }
      })
      .catch((error) => {
        // Log and handle errors
        console.error("Error occurred:", error);
        toast.error(error.message || "An unexpected error occurred.");
      });
  };

  return (
    <>
      <Helmet>
        <title>IzzyAI - AI-Powered Speech Therapy</title>
        <meta name="description"
          content="IzzyAI: Transforming speech therapy with innovative AI. Access 24/7 personalized care via an AI therapist powered by real-time recognition and analytics."
        />
      </Helmet>
      <div className="2xl:px-6 xl:px-6 lg:px-6 md:px-6 px-1 pt-3 2xl:pt-6 xl:pt-6 lg:pt-6 md:pt-6  mx-auto 2xl:pb-20 xl:pb-20 md:pb-20 pb-10">
        <h1 className="text-2xl font-bold mb-4 text-center dark:text-white">
          Your Cart
        </h1>

        {/* Checkbox 1 */}
        <div className="flex flex-wrap md:flex-nowrap items-center gap-4  p-4 pb-8 rounded-md">
          {/* Period Dropdown */}
          <div className="w-full md:w-2/3   rounded-md box-shadow-around bg-[#cbd5e1] dark:bg-[#323c49] mb-5">
            <div className="flex flex-wrap 2xl:flex-nowrap xl:flex-nowrap lg:flex-nowrap md:flex-none justify-between mx-5 mb-5 mt-5 align-top">
              <div className="flex justify-center 2xl:w-64 xl:w-64 lg:w-64 md:w-64    w-full">
                <div className="w-40 2xl:w-60 xl:w-60 lg:w-60 md:w-60 sm:w-60">
                  <label className="flex 2xl:block xl:block lg:block md:block text-sm font-medium  mb-2  text-[#a3a3b0] 2xl:justify-start xl:justify-start lg:justify-start md:justify-start justify-center">
                    Select Period
                  </label>
                  <select
                    className="w-40 2xl:w-60 xl:w-60 lg:w-60 md:w-60 sm:w-60 border border-gray-300 rounded-md p-2 focus:outline-none"
                    value={period}
                    onChange={handlePeriodChange}
                  >
                    <option value="1">1 Month</option>
                    <option value="12">1 Year</option>
                  </select>
                </div>
              </div>
              <div className="flex items-center 2xl:mt-0 xl:mt-0 lg:mt-0 md:mt-0 mt-10">
                <p className="text-lg font-bold dark:text-white">
                  US$ {period === "1" ? 152 : 881}
                </p>
              </div>
            </div>
            <div className="mx-5 mb-5 text-[#3f3f3f] dark:text-[#a3a3b0]">
              <p>
                Renews at US ${period === "1" ? "152/month" : "881/annual"} on{" "}
                {renewalDate}.
              </p>
            </div>
            <div
              className={`mx-5 mb-5 bg-[#f2f3f7] rounded-lg ${period === "1" ? "" : "hidden"
                }`}
            >
              <p className="text-center">
                <span className="text-lg text-gray-500 dark:text-gray-400 line-through mb-1 mr-1">
                  $1824
                </span>
                <span className="text-sm  font-medium text-green-600 dark:text-green-400">
                  Save over 50%
                </span>
              </p>
              <p className="px-4 py-2 text-center">
                Opt for a 12-month plan to get discount of $943 (-50%).
              </p>
            </div>
          </div>

          {/* Amount */}
          <div className="w-full  md:w-1/3  rounded-md box-shadow-around bg-[#cbd5e1] dark:bg-[#323c49]">
            <div className="flex flex-wrap md:flex-nowrap items-center   p-4  rounded-md">
              {/* Subtotal */}
              <div className="w-full md:w-2/3 pr-4">
                <p className="text-lg font-medium dark:text-white">Subtotal</p>
              </div>

              {/* Value */}
              <div className="w-full md:w-1/3 mt-4 md:mt-0">
                <p className="text-lg font-bold dark:text-white">
                  US$ {period === "1" ? 152 : 881}
                </p>
              </div>
            </div>

            {/* Invoice ID Input */}
            {/* <div className="mb-4 p-4">
            <label className="block text-sm font-medium text-[#3f3f3f] dark:text-[#a3a3b0] mb-2">
              Invoice ID
            </label>
            <input
              type="text"
              placeholder="Enter invoice ID"
              className="w-full border border-gray-300 rounded-md p-2 focus:outline-none"
              value={invoiceId}
              onChange={(e) => setInvoiceId(e.target.value)}
            />
          </div> */}

            {/* Pay Button */}
            <div className="px-4 pb-4">
              <button
                onClick={handlePay}
                className="w-full hover:bg-[#1d1f22] bg-[#404246] text-white font-bold py-2 px-4 rounded-md"
              >
                <FontAwesomeIcon className="pr-2" icon={faLock} />
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CheckOut;
